/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./ChatView.vue?vue&type=template&id=96f3dc52"
import script from "./ChatView.vue?vue&type=script&lang=js"
export * from "./ChatView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src686490483/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('96f3dc52')) {
      api.createRecord('96f3dc52', component.options)
    } else {
      api.reload('96f3dc52', component.options)
    }
    module.hot.accept("./ChatView.vue?vue&type=template&id=96f3dc52", function () {
      api.rerender('96f3dc52', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ChatView.vue"
export default component.exports